import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { authenticatedUserState } from '../services/state/AuthState';
import { toggleDebugData } from './debugUser';

export function useDebugKeyboard() {
  const fronteggUser = useAtomValue(authenticatedUserState);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        toggleDebugData(fronteggUser);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [fronteggUser]);
}
